import lpApp from '../lp_app';
import lpevents from '../../tracking/lpevents';

/*
 * Project: LegalPlace assistant
 * File: src/app/ops/slack_notifications.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

export default class LpSlackOps {
  constructor() {
    this.channel = '';
    this.icon = ':euro:';
  }

  static sendNotification(json = {}, callback = null) {
    fetch('https://hooks.slack.com/services/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', {
      headers: {
        // "Accept": "application/json",
        // "Content-Type": "application/json"
      },
      body: JSON.stringify(json),
      method: 'POST',
    }).then(async () => {
      // console.log(await resp.text())
      if (callback) callback();
    }).catch(async (err) => {
      // console.log(await err.text())

      if (callback) callback();
    });
  }
  sendContinueMessage(a) {
    const quote = (a === 'Validate') ? ' a valider sa démarche : ' : ' a enregistrer sa démarche : ';
    const color = (a === 'Validate') ? '#36A64F' : '#669BCC';

    const json = {
      username: 'Suivi Création',
      icon_emoji: this.icon,
      channel: '#dossier-updated-crea',
      attachments: [
        {
          text:
                                    `${lpApp.getState().account_settings.mail
                                    + quote
                                    + lpApp.getState().contract.name
                                    }\n<${window.location.href}|Questionnaire>`
                                    + ` - <https://www.legalplace.fr/telecharger/${lpApp.continuity.continue}|Documents>`,
          color,

        },
      ],
    };

    // Adding Environement to username when needed
    if (typeof (window.lp_env) === 'string' && window.lp_env !== 'prod') {
      json.username += ` - Environement:  ${window.lp_env}`;
      json.attachments[0].text = `:warning: *CECI EST UN TEST -* ${json.attachments[0].text}`;
    }

    if (lpApp.isPayed) {
      LpSlackOps.sendNotification(json);
    }
  }

  sendCustomeSlack() {
    const variablesExtraction = lpApp.references.slack_notification.saveSlack;

    /*
        let slackExtractions = {};
        for(var i = 0; i < variablesExtraction.length; i += 1){
          let current_slackExtraction = variablesExtraction[i].extractions.slack;

          if(current_slackExtraction.enabled === true){
            let current_value = variablesExtraction[i].value;
            if(!(current_slackExtraction.channel in slackExtractions)){
              slackExtractions[current_slackExtraction.channel] = [];
            }

            slackExtractions[current_slackExtraction.channel].push({
              title: current_slackExtraction.name,
              value: current_value,
              short: true
            });
          }
        }
*/
    variablesExtraction.forEach((idx) => {
      // Making sure variable is defined
      if (typeof (lpApp.references.variables[idx.id]) === 'undefined') return;

      const json = {
        username: idx.name,
        icon_emoji: this.icon,
        channel: idx.channel,
        attachments: [
          {
            text: `eMail : ${lpApp.getState().account_settings.mail} \n ${lpApp.references.variables[idx.id].label} : ${lpApp.indexes.variables.getVariable(idx.id) ? lpApp.indexes.variables.getVariable(idx.id).value : ' Not mentionned'}`,
          },
        ],

      };

      // Adding Environement to username when needed
      if (typeof (window.lp_env) === 'string' && window.lp_env !== 'prod') {
        json.username += ` - Environement:  ${window.lp_env}`;
        json.attachments[0].text = `:warning: *CECI EST UN TEST -* ${json.attachments[0].text}`;
      }

      LpSlackOps.sendNotification(json);
    }, this);
  }

  generateMixpanel() {
    const mx = lpApp.references.slack_notification.mixpanel;
    const evt = {};
    mx.forEach((idx) => {
      evt[idx.name] = idx.type === 'option' ? LpSlackOps.extractOption(idx) : LpSlackOps.extractVariable(idx);
    });
  }

  static extractVariable(idx) {
    return lpApp.indexes.variables.getVariable(idx.id) ? lpApp.indexes.variables.getVariable(idx.id).value : 'No value';
  }

  static extractOption(idx) {
    return lpApp.indexes.options.getOption(idx.id) ? lpApp.indexes.options.getOption(idx.id).value : 'No value';
  }

  generateSendinBlue(eventName) {
    const sib = lpApp.references.slack_notification.sendinblue;
    const evt = {};
    sib.forEach((idx) => {
      evt[idx.name] = idx.type === 'option' ? LpSlackOps.extractOption(idx) : LpSlackOps.extractVariable(idx);
    });

    lpevents.trackSIB(eventName, evt);
  }

  sendExtractionAttributesSBToDatalayer(sbDataIdentify = {}){
    const sib = lpApp.references.slack_notification.sendinblue;
    const evt = {...sbDataIdentify};
    sib.forEach((idx) => {
      evt[idx.name] = idx.type === 'option' ? LpSlackOps.extractOption(idx) : LpSlackOps.extractVariable(idx);
    });

    lpevents.trackDatalayerSendinBlue(evt);
  }
}



// WEBPACK FOOTER //
// ./src/app/ops/slack_notifications.js